/// <amd-module name="Dashboards/WidgetCommon/DashboardsCacheableQueryService" />
import { CacheableQueryService, ICacheableQueryService } from "Reporting/Common/CacheableQueryService";

import {
    DashboardsNotificationServiceActions,
    IDashboardsNotificationService,
    IDashboardsNotificationServiceName
} from "Dashboards/Common/DashboardsNotificationService";

import { IVssPageContext, Services } from "VSS/Platform/Context";

export { ICacheableQueryService };
export const IDashboardsCacheableQueryServiceName = "IDashboardsCacheableQueryService";

/**
 * An In-memory implementation for dashboards client cache of shared query results.
 * Extends Reporting CacheableQueryService to allow dashboard to notify it of refresh via DashboardsNotificationService and clear the cache
 */
class DashboardsCacheableQueryService extends CacheableQueryService {
    private notificationService: IDashboardsNotificationService;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);

        this.notificationService = this.pageContext.getService<IDashboardsNotificationService>(IDashboardsNotificationServiceName);
        this.notificationService.subscribe(this.notificationListener);
    }

    private notificationListener = (payload: any, action: string): void => {
        if (action === DashboardsNotificationServiceActions.DashboardRefreshingAction) {
            this.resetCache();
        }
    };
}

Services.add(IDashboardsCacheableQueryServiceName, { serviceFactory: DashboardsCacheableQueryService });
